module.exports = __webpack_public_path__ + "img/no_data.98d64b9e.png";